'use client'
import { Icon } from '@/components'
import { Box, Grid, Stack, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'
import { useParams, useRouter } from 'next/navigation'
import { useState } from 'react'
import { TContentByKey } from '../types'
export const Categories = ({ categories }: { categories: TContentByKey[] }) => {
  const [activeKey, setActiveKey] = useState<string>()
  const params = useParams()
  const router = useRouter()
  const { detail } = params

  const handleClick = (key: string) => {
    setActiveKey(key)
    router.push(`/help/${key}`)
  }

  const isActive = (key: string) => key === activeKey || detail === key
  const t = useTranslations()
  return (
    <Stack spacing={2}>
      <Typography
        variant="h2"
        sx={{
          fontSize: {
            xs: '1.5rem',
            md: '2rem',
          },
          lineHeight: 1.5,
          fontWeight: 800,
          textTransform: 'uppercase',
          textAlign: { xs: 'center', md: 'unset' },
        }}
      >
        <Box component="span" sx={{ color: 'primary.main' }}>
          {t('Trung tâm hỗ trợ')}
        </Box>{' '}
        <Box component="span" sx={{ display: { xs: 'block', sm: 'inline' } }}>
          {t('KHÁCH HÀNG')}
        </Box>
      </Typography>
      <Grid
        sx={{
          background: { xs: '#ffffffa5', md: 'transparent' },
          padding: { xs: '10px', md: 0 },
          borderRadius: '8px',
        }}
        container
        spacing={{ xs: 1, md: 2 }}
      >
        {categories.map((item, index) => (
          <Grid size={{ xs: 6, sm: 4, md: 12 }} key={index}>
            <Stack
              onClick={() => handleClick(item?.key)}
              direction="row"
              gap={0.5}
              sx={{
                position: 'relative',
                width: 'fit-content',
                '&:hover': {
                  '& .arrow-icon': {
                    opacity: 1,
                    visibility: 'visible',
                    transform: 'translateX(0)',
                    width: 16,
                  },
                  '& .title-text': {
                    color: 'primary.main',
                  },
                },
                cursor: 'pointer',
              }}
            >
              <Icon.ArrowRight
                className="arrow-icon"
                sx={{
                  marginTop: '3px',
                  width: isActive(item.key) ? 16 : 0,
                  height: 16,
                  flexShrink: 0,
                  color: 'primary.main',
                  opacity: isActive(item?.key) ? 1 : 0,
                  transition: 'all 0.2s ease-in-out',
                  transform: isActive(item?.key) ? 'translateX(0px)' : 'translateX(-10px)',
                  display: { xs: 'none', md: 'block' },
                }}
              />
              <Typography
                key={index}
                variant="h3"
                className="title-text"
                sx={{
                  fontSize: { xs: '0.75rem', md: '1rem', lineHeight: 1.5, fontWeight: 700 },
                  color: isActive(item.key) ? 'primary.main' : '',
                }}
              >
                {' '}
                {item?.name}
              </Typography>
            </Stack>
          </Grid>
        ))}
      </Grid>
    </Stack>
  )
}
